const Data =[
    {   
        id: "h1",
        image:"https://a0.muscache.com/im/pictures/73969763-6895-4198-bd2b-4975b5858b69.jpg?im_w=720",
        location: "Terilunga, Texas, US",
        stars: 4.5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,2,20),
        checkOutDate: new Date(2023,2,25),
        price: "6,982",
        time: "night" ,
        hotelType:"Amazing views"
    },
    {   
        id: "h2",
        image:"https://a0.muscache.com/im/pictures/miso/Hosting-801942887277808738/original/73427380-2d84-492e-80cc-cb9c4c4b785c.jpeg?im_w=720",
        location: "Pollenca ,Spain",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,4,1),
        checkOutDate: new Date(2023,4, 8),
        price: "16,169",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h3",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-812791907527450558/original/ffff208a-79aa-460e-a979-4e520d0261a0.jpeg?im_w=720",
        location: "Supetar ,Croatia",
        stars: 4.5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,4,14),
        checkOutDate: new Date(2023,4, 21),
        price: "14,65",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h4",
        image:"https://a0.muscache.com/im/pictures/068070a7-9bc4-4fd8-8f24-68f1811e12cc.jpg?im_w=720",
        location: "Pan de Azucar ,Uruguay",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,3,5),
        checkOutDate: new Date(2023,3, 10),
        price: "2,657",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h5",
        image:"https://a0.muscache.com/im/pictures/miso/Hosting-708862697545376424/original/4d8a55c9-8ee7-467d-9792-82808192e88c.jpeg?im_w=720",
        location: "Lawrence, Kansas ,USA",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,3,1),
        checkOutDate: new Date(2023,3, 7),
        price: "2,165",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h6",
        image:"https://a0.muscache.com/im/pictures/miso/Hosting-721354533511818751/original/e9787333-5cc7-4d75-822d-fe3111074b79.jpeg?im_w=720",
        location: "Kecamatan Kuta Utra ,Indonesia",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,3,4),
        checkOutDate: new Date(2023,3, 10),
        price: "23,657",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h7",
        image:"https://a0.muscache.com/im/pictures/miso/Hosting-721354533511818751/original/e9787333-5cc7-4d75-822d-fe3111074b79.jpeg?im_w=720",
        location: "Kecamatan Kuta Utra ,Indonesia",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,3,4),
        checkOutDate: new Date(2023,3, 10),
        price: "24,657",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h8",
        image:"https://a0.muscache.com/im/pictures/miso/Hosting-786959616046460308/original/a72daf1a-2a83-44b3-b68f-2a0ab9b487a1.jpeg?im_w=720",
        location: "Lac-Beauport ,Canada",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,3,30),
        checkOutDate: new Date(2023,4, 6),
        price: "8,033",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h9",
        image:"https://a0.muscache.com/im/pictures/miso/Hosting-554134218754259893/original/439d6e95-0ba0-49f7-8ccd-1bfff408a696.jpeg?im_w=720",
        location: "Kissimmee, Florida, USA",
        stars: 4,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,4,9),
        checkOutDate: new Date(2023,4, 15),
        price: "15,824",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h10",
        image:"https://a0.muscache.com/im/pictures/miso/Hosting-806613886057083262/original/06347c44-554b-4255-b94f-ef1c6692a923.jpeg?im_w=720",
        location: "Picanda Cafe, Brazil",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,4,19),
        checkOutDate: new Date(2023,4, 25),
        price: "6,247",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h11",
        image:"https://a0.muscache.com/im/pictures/0de7a082-b382-49da-9953-e99c0b91b71e.jpg?im_w=720",
        location: "HartelsBerg, Austria",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,3,27),
        checkOutDate: new Date(2023,4, 3),
        price: "10,081",
        time: "night",
        hotelType:"Amazing views"
    },
    {   
        id: "h12",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,2,28),
        checkOutDate: new Date(2023,3, 5),
        price: "5,813",
        time: "night",
        hotelType:"Amazing views"
    },
    {
        id: "h13",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Amazing views"
    },
    {
        id: "h14",
        image:"https://a0.muscache.com/im/pictures/miso/Hosting-42685161/original/52b9c580-e69a-47a1-9a52-be14b3ef2ddf.jpeg?im_w=720",
        location: "Coly-da-rel, France",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Farms"
    },
    {
        id: "h15",
        image:"https://a0.muscache.com/im/pictures/b0c72936-387b-445d-8cb1-a1e4719d2733.jpg?im_w=720",
        location: "Betrimoutier, France",
        stars: 4.5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Farms"
    },
    {
        id: "h16",
        image:"https://a0.muscache.com/im/pictures/d08403c0-bd7d-4579-a818-8b0b43649de3.jpg?im_w=720",
        location: "Mayen, Germany",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Farms"
    },
    {
        id: "h17",
        image:"https://a0.muscache.com/im/pictures/64075d6e-574f-489b-b689-1d7bc89659d5.jpg?im_w=720",
        location: "Maastrincht, Netherlands",
        stars: 5,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Farms"
    },
    {
        id: "h18",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Farms"
    },
    {
        id: "h19",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Amazing views"
    },
    {
        id: "h20",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Amazing views"
    },
    {
        id: "h21",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Amazing views"
    },
    {
        id: "h22",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Amazing views"
    },
    {
        id: "h22",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Countryside"
    },
    {
        id: "h23",
        image:"https://a0.muscache.com/im/pictures/prohost-api/Hosting-802046688702639730/original/24f55ed5-8c10-405c-b7e4-74ee222992e1.jpeg?im_w=720",
        location: "Hickleton, UK",
        stars: 3,
        info: "Lorem ipsum dolor sit",
        checkInDate: new Date(2023,5,5),
        checkOutDate: new Date(2023,5, 11),
        price: "6,813",
        time: "night",
        hotelType:"Countryside"
    }
]
export default Data;